var _defs, _path, _circle, _tspan, _path2, _circle2, _text, _path3, _circle3, _text2, _path4, _circle4, _text3, _path5, _circle5, _tspan2, _path6, _circle6, _text4, _path7, _circle7, _text5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFutureHorizontal = function SvgFutureHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "future_horizontal_svg__Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2204.82 485"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "future_horizontal_svg__drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "future_horizontal_svg__drop-shadow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "future_horizontal_svg__drop-shadow-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "future_horizontal_svg__drop-shadow-4",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "future_horizontal_svg__drop-shadow-5",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-5",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "future_horizontal_svg__drop-shadow-6",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-6",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-6",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "future_horizontal_svg__drop-shadow-7",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-7",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-7",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "future_horizontal_svg__drop-shadow-8",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-8",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-8",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "future_horizontal_svg__drop-shadow-9",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-9",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-9",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "future_horizontal_svg__OmbreQueue",
    "data-name": "D\\xE9grad\\xE9 sans nom 29",
    x1: 427.5,
    y1: 292.84,
    x2: 399.75,
    y2: 216.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d28282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#ef9f99"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "future_horizontal_svg__OmbreQueue-2",
    "data-name": "D\\xE9grad\\xE9 sans nom 29",
    x1: -5413.67,
    y1: -5564,
    x2: -5441.49,
    y2: -5640.45,
    gradientTransform: "scale(1 -1) rotate(87.39 -5212.55 128.667)",
    xlinkHref: "#future_horizontal_svg__OmbreQueue"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "future_horizontal_svg__OmbreQueue-3",
    "data-name": "D\\xE9grad\\xE9 sans nom 29",
    x1: 719.63,
    y1: 292.84,
    x2: 691.88,
    y2: 216.61,
    xlinkHref: "#future_horizontal_svg__OmbreQueue"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "future_horizontal_svg__OmbreQueue-4",
    "data-name": "D\\xE9grad\\xE9 sans nom 29",
    x1: -5400.38,
    y1: -5855.83,
    x2: -5428.2,
    y2: -5932.28,
    gradientTransform: "scale(1 -1) rotate(87.39 -5212.55 128.667)",
    xlinkHref: "#future_horizontal_svg__OmbreQueue"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "future_horizontal_svg__OmbreQueue-5",
    "data-name": "D\\xE9grad\\xE9 sans nom 29",
    x1: 1011.98,
    x2: 984.24,
    xlinkHref: "#future_horizontal_svg__OmbreQueue"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "future_horizontal_svg__OmbreQueue-6",
    "data-name": "D\\xE9grad\\xE9 sans nom 29",
    x1: -5387.09,
    y1: -6147.88,
    x2: -5414.91,
    y2: -6224.32,
    gradientTransform: "scale(1 -1) rotate(87.39 -5212.55 128.667)",
    xlinkHref: "#future_horizontal_svg__OmbreQueue"
  }), /*#__PURE__*/React.createElement("style", null, ".future_horizontal_svg__cls-3,.future_horizontal_svg__cls-4{fill:#4c4c4c}.future_horizontal_svg__cls-4{font-size:17px}.future_horizontal_svg__cls-5,.future_horizontal_svg__cls-6{font-family:inherit}.future_horizontal_svg__cls-20{stroke-miterlimit:10;fill:none;stroke:#4c4c4c}"))), /*#__PURE__*/React.createElement("g", {
    id: "future_horizontal_svg__Accueil"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.27 238.43c28.34 78 103.12 133.72 190.91 133.72 57.37 0 109.18-23.79 146.11-62.04 35.26-36.53 56.95-86.24 56.95-141.02 0-2.28-.04-4.56-.11-6.82-2.4-72.75-111.28-72.75-113.69 0-.07 2.26-.11 4.54-.11 6.82 0 54.78 21.69 104.49 56.96 141.02 36.92 38.25 88.73 62.04 146.1 62.04s109.18-23.79 146.11-62.04c35.26-36.53 56.95-86.24 56.95-141.02 0-2.28-.04-4.56-.11-6.82-2.4-72.75-111.28-72.75-113.69 0-.07 2.26-.11 4.54-.11 6.82 0 54.78 21.69 104.49 56.96 141.02 36.92 38.25 88.73 62.04 146.1 62.04s109.18-23.79 146.1-62.04c35.27-36.53 56.96-86.24 56.96-141.02 0-2.28-.04-4.56-.11-6.82-2.4-72.75-111.28-72.75-113.69 0-.07 2.26-.11 4.54-.11 6.82 0 54.78 21.69 104.49 56.95 141.02 36.93 38.25 88.74 62.04 146.11 62.04h1000",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 50,
      stroke: "#ef9f99",
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.54 308.04c12.58-10.7 24.39-22.82 34.76-37.15-9.41-13.85-17.52-29.33-23.78-47.56l-48.4 12c8.24 26.92 20.84 50.89 37.42 72.71Z",
    style: {
      fill: "url(#future_horizontal_svg__OmbreQueue)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.3 344.14c11.14-9.33 25.41-24.81 34.77-36.1 13.71 10.7 27.49 19.99 50.35 28.5l-13.83 48c-27.96-9.82-50.25-22.85-71.3-40.4Z",
    style: {
      fill: "url(#future_horizontal_svg__OmbreQueue-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M706.67 308.04c12.58-10.7 24.39-22.82 34.76-37.15-9.41-13.85-17.52-29.33-23.78-47.56l-48.4 12c8.24 26.92 20.84 50.89 37.42 72.71Z",
    style: {
      fill: "url(#future_horizontal_svg__OmbreQueue-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.43 344.14c11.14-9.33 25.41-24.81 34.77-36.1 13.71 10.7 27.49 19.99 50.35 28.5l-13.83 48c-27.96-9.82-50.25-22.85-71.3-40.4Z",
    style: {
      fill: "url(#future_horizontal_svg__OmbreQueue-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.02 308.04c12.58-10.7 24.39-22.82 34.76-37.15-9.41-13.85-17.52-29.33-23.78-47.56l-48.4 12c8.24 26.92 20.84 50.89 37.42 72.71Z",
    style: {
      fill: "url(#future_horizontal_svg__OmbreQueue-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1033.78 344.14c11.14-9.33 25.41-24.81 34.77-36.1 13.71 10.7 27.49 19.99 50.35 28.5l-13.83 48c-27.96-9.82-50.25-22.85-71.3-40.4Z",
    style: {
      fill: "url(#future_horizontal_svg__OmbreQueue-6)"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "future_horizontal_svg__cls-20",
    d: "M1033.04 61.24v44.61"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "future_horizontal_svg__cls-3",
    cx: 1033.04,
    cy: 105.66,
    r: 3.76
  })), /*#__PURE__*/React.createElement("rect", {
    x: 926.92,
    y: 6.9,
    width: 212.87,
    height: 55.34,
    rx: 5,
    ry: 5,
    style: {
      filter: "url(#future_horizontal_svg__drop-shadow-3)",
      fill: "#bee5cf"
    }
  }), /*#__PURE__*/React.createElement("text", {
    className: "future_horizontal_svg__cls-4",
    transform: "translate(999.27 29.24)"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    className: "future_horizontal_svg__cls-6"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Fin 2025"))), /*#__PURE__*/React.createElement("tspan", {
    className: "future_horizontal_svg__cls-5"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -13.28,
    y: 20.4,
    style: {
      letterSpacing: 0
    }
  }, "Expansion \uD83C\uDF0E"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "future_horizontal_svg__cls-20",
    d: "M897.53 417.92v-44.61"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "future_horizontal_svg__cls-3",
    cx: 897.53,
    cy: 373.5,
    r: 3.76
  })), /*#__PURE__*/React.createElement("rect", {
    x: 770.78,
    y: 416.92,
    width: 250,
    height: 55.34,
    rx: 5,
    ry: 5,
    transform: "rotate(180 897.215 444.59)",
    style: {
      filter: "url(#future_horizontal_svg__drop-shadow-4)",
      fill: "#bee5cf"
    }
  }), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "future_horizontal_svg__cls-4",
    transform: "translate(845.44 439.46)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "future_horizontal_svg__cls-6"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Courant 2025")), /*#__PURE__*/React.createElement("tspan", {
    className: "future_horizontal_svg__cls-5"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -57,
    y: 20.4
  }, "Arriv\xE9e des nouveaux projets")))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "future_horizontal_svg__cls-20",
    d: "M740.78 61.24v44.61"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "future_horizontal_svg__cls-3",
    cx: 740.78,
    cy: 105.66,
    r: 3.76
  })), /*#__PURE__*/React.createElement("rect", {
    x: 634.66,
    y: 6.9,
    width: 212.87,
    height: 55.34,
    rx: 5,
    ry: 5,
    style: {
      filter: "url(#future_horizontal_svg__drop-shadow-5)",
      fill: "#bee5cf"
    }
  }), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "future_horizontal_svg__cls-4",
    transform: "translate(720.9 29.24)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "future_horizontal_svg__cls-6"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24,
    y: 0
  }, "D\xE9but 2025")), /*#__PURE__*/React.createElement("tspan", {
    className: "future_horizontal_svg__cls-5"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -56.34,
    y: 20.4
  }, "S\xE9lection des projets")))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "future_horizontal_svg__cls-20",
    d: "M600.44 417.92v-44.61"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "future_horizontal_svg__cls-3",
    cx: 600.44,
    cy: 373.5,
    r: 3.76
  })), /*#__PURE__*/React.createElement("rect", {
    x: 493.69,
    y: 416.92,
    width: 212.87,
    height: 55.34,
    rx: 5,
    ry: 5,
    transform: "rotate(180 600.125 444.59)",
    style: {
      filter: "url(#future_horizontal_svg__drop-shadow-6)",
      fill: "#bee5cf"
    }
  }), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "future_horizontal_svg__cls-4",
    transform: "translate(567.04 439.46)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "future_horizontal_svg__cls-6"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Fin 2024")), /*#__PURE__*/React.createElement("tspan", {
    className: "future_horizontal_svg__cls-5"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -15,
    y: 20.4
  }, "Appel \xE0 projet")))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "future_horizontal_svg__cls-20",
    d: "M449.51 61.24v44.61"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "future_horizontal_svg__cls-3",
    cx: 449.51,
    cy: 105.66,
    r: 3.76
  })), /*#__PURE__*/React.createElement("rect", {
    x: 343.39,
    y: 6.9,
    width: 212.87,
    height: 55.34,
    rx: 5,
    ry: 5,
    style: {
      fill: "#bee5cf",
      filter: "url(#future_horizontal_svg__drop-shadow-7)"
    }
  }), /*#__PURE__*/React.createElement("text", {
    className: "future_horizontal_svg__cls-4",
    transform: "translate(416.02 29.24)"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    className: "future_horizontal_svg__cls-6"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Mi-2024"))), /*#__PURE__*/React.createElement("tspan", {
    className: "future_horizontal_svg__cls-5"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -50,
    y: 20.4,
    style: {
      letterSpacing: "-.02em"
    }
  }, "D\xE9but du crowdfunding"))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "future_horizontal_svg__cls-20",
    d: "M303.36 417.92v-44.61"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "future_horizontal_svg__cls-3",
    cx: 303.36,
    cy: 373.5,
    r: 3.76
  })), /*#__PURE__*/React.createElement("rect", {
    x: 196.61,
    y: 416.92,
    width: 212.87,
    height: 55.34,
    rx: 5,
    ry: 5,
    transform: "rotate(180 303.04 444.59)",
    style: {
      filter: "url(#future_horizontal_svg__drop-shadow-8)",
      fill: "#bee5cf"
    }
  }), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "future_horizontal_svg__cls-4",
    transform: "translate(259.11 439.46)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "future_horizontal_svg__cls-6"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Mars 2024")), /*#__PURE__*/React.createElement("tspan", {
    className: "future_horizontal_svg__cls-5"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -32.13,
    y: 20.4
  }, "Premi\xE8re campagne")))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "future_horizontal_svg__cls-20",
    d: "M112.2 190.92v44.61"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "future_horizontal_svg__cls-3",
    cx: 112.2,
    cy: 235.34,
    r: 3.76
  })), /*#__PURE__*/React.createElement("rect", {
    x: 6.08,
    y: 136.58,
    width: 212.87,
    height: 55.34,
    rx: 5,
    ry: 5,
    style: {
      filter: "url(#future_horizontal_svg__drop-shadow-9)",
      fill: "#bee5cf"
    }
  }), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "future_horizontal_svg__cls-4",
    transform: "translate(92.33 158.92)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "future_horizontal_svg__cls-6"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -20,
    y: 0
  }, "Mars 2024")), /*#__PURE__*/React.createElement("tspan", {
    className: "future_horizontal_svg__cls-5"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -77.01,
    y: 20.4
  }, "Lancement de KuneKune"))))));
};
export default SvgFutureHorizontal;